import { Link, useForm } from '@inertiajs/react'
import AppLayout from '@/layouts/AppLayout'
import { PageContainer } from '@/components/PageContainer'
import { PageHeader } from '@/components/PageHeader'
import { FlashBanner } from '@/components/FlashBanner'
import { FormField } from '@/components/FormField'
import { FieldError } from '@/components/FieldError'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { cn } from '@/lib/utils'
import type { ProjectNav } from '@/types/project'

interface Props {
  project_nav: ProjectNav
}

const ROLES = [
  {
    value: 'member',
    label: 'メンバー',
    description: '要件定義の閲覧・編集・修正依頼が可能'
  },
  {
    value: 'admin',
    label: '管理者',
    description: 'メンバー権限に加え、招待・設定変更・削除が可能'
  }
]

export default function InvitationsNew ({ project_nav: project }: Props): React.ReactElement {
  const { data, setData, post, processing, errors } = useForm({
    email: '',
    role: 'member'
  })

  function handleSubmit (e: React.SubmitEvent): void {
    e.preventDefault()
    post(`/projects/${project.id}/invitations`)
  }

  return (
    <AppLayout project={project}>
      <PageContainer maxWidth='580px'>
        <PageHeader
          title='メンバーを招待する'
          backHref={`/projects/${project.id}/memberships`}
          backLabel='メンバー'
        />

        <FlashBanner />

        <form onSubmit={handleSubmit}>
          <div className='bg-(--bp-surface) border border-(--bp-border) rounded-[10px]'>
            <div className='p-6'>
              <FormField label='メールアドレス' required>
                <Input
                  type='email'
                  value={data.email}
                  onChange={(e) => setData('email', e.target.value)}
                  placeholder='recruit@example.com'
                />
                <FieldError message={errors.email} />
              </FormField>

              <FormField label='権限'>
                <div className='flex flex-col gap-2 mt-1.5'>
                  {ROLES.map((role) => (
                    <label
                      key={role.value}
                      className={cn(
                        'flex items-start gap-[10px] px-[14px] py-3 cursor-pointer border-[1.5px] rounded-lg',
                        data.role === role.value
                          ? 'border-(--bp-accent) bg-(--bp-accent-pale)'
                          : 'border-(--bp-border) bg-transparent'
                      )}
                    >
                      <input
                        type='radio'
                        name='role'
                        value={role.value}
                        checked={data.role === role.value}
                        onChange={() => setData('role', role.value)}
                        className='mt-0.5'
                      />
                      <div>
                        <div className='text-[13px] font-semibold text-(--bp-ink)'>{role.label}</div>
                        <div className='text-[11px] text-(--bp-ink3) mt-0.5'>{role.description}</div>
                      </div>
                    </label>
                  ))}
                </div>
              </FormField>
            </div>
            <div className='px-6 py-4 bg-(--bp-surface2) border-t border-(--bp-border) rounded-b-[10px] flex gap-2 justify-end'>
              <Button asChild variant='outline'>
                <Link href={`/projects/${project.id}/memberships`}>
                  キャンセル
                </Link>
              </Button>
              <Button type='submit' disabled={processing}>
                招待メールを送る
              </Button>
            </div>
          </div>
        </form>
      </PageContainer>
    </AppLayout>
  )
}
